
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/category/[filename]",
      function () {
        return require("private-next-pages/guides/category/[filename].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/category/[filename]"])
      });
    }
  